<div class="row no-gutters mb-product-gallery"
     data-cy="mbProductGallery"
     *ngIf="product$ | async">

  <div class="col-3 mr-md-3 mb-carousel-wrapper"
       *ngIf="hasApplicationData$ | async">
    <mb-pdp-gallery-carousel
      [imagesData]="productGallery$ | async"
      (activeImage)="onGalleryClickedHandler($event)"
      [videoThumbnails]="thumbnails">
    </mb-pdp-gallery-carousel>
  </div>

  <div *ngIf="!!activeImage"
       data-cy="mbGalleryMainImageWrapper"
       [ngClass]="[(hasApplicationData$ | async) ? 'col-9' : 'col-12',
                    (isImageClickable$ | async) ? 'cursor-pointer' : '',
                    'mb-carousel-thumbnail use-to-remove-blocker']"
       (click)="onThumbnailImageClickHandler()">
    <ng-container *ngIf="activeImage?.videoId; else showImage">
      <ng-container *ngIf="!(isScreenForSmallDevices() | async)">
        <ng-container *ngIf="getThumbnail(activeImage?.videoId) as thumbnail">
          <span *ngIf="thumbnail.image"
                mbUcBlockable
                [ucId]="activeImage?.videoId"
                [ucService]="ucService.MOVING_IMAGE">
            <img src="../../../../../assets/images/Icon_play-xl2_white.svg"
                 class="mb-thumbnail-video-play-button"
                 data-cy="mb-thumbnail-video-play-button"
                 alt="play video"
                 title="play video"/>

            <picture>
              <source [srcset]="thumbnail.image">
              <img
                [ngClass]="[(hasApplicationData$ | async) ? 'pl-3 pl-md-0' : '', 'mb-gallery-image h-100 img-responsive']"
                [title]="thumbnail.legend"
                [alt]="thumbnail.legend"
                [attr.aria-label]="'mbproduct.galleryMainImage' | mbTranslate"
                data-cy="panel-row-video-image"
                [src]="thumbnail.image"/>
            </picture>
          </span>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="isScreenForSmallDevices() | async">
        <ng-container *ngIf="getThumbnailForSmallDevices(activeImage?.videoId) as thumbnail">
          <span *ngIf="thumbnail.image"
                mbUcBlockable
                [ucId]="activeImage?.videoId"
                [ucService]="ucService.MOVING_IMAGE">
            <img src="../../../../../assets/images/Icon_play-xl2_white.svg"
                 class="mb-thumbnail-video-play-button"
                 data-cy="mb-thumbnail-video-play-button"
                 alt="play video"
                 title="play video"/>
            <picture>
              <source [srcset]="thumbnail.image">
              <img
                [ngClass]="[(hasApplicationData$ | async) ? 'pl-3 pl-md-0' : '', 'mb-gallery-image mb-video h-100 img-responsive']"
                [title]="thumbnail.legend"
                [alt]="thumbnail.legend"
                [attr.aria-label]="'mbproduct.galleryMainImage' | mbTranslate"
                data-cy="panel-row-video-image"
                [src]="thumbnail.image"/>
            </picture>
          </span>
        </ng-container>
      </ng-container>

    </ng-container>

    <ng-template #showImage>
      <img
        [ngClass]="[(hasApplicationData$ | async) ? 'pl-3 pl-md-0' : '', 'mb-gallery-image h-100']"
        [title]="'mbproduct.galleryMainImage' | mbTranslate"
        [alt]="'mbproduct.galleryMainImage' | mbTranslate"
        [attr.aria-label]="'mbproduct.galleryMainImage' | mbTranslate"
        data-toggle="modal"
        [src]="activeImage.image || placeholderImage"/>
    </ng-template>
  </div>
</div>
